import React from 'react';
import { Image, Page, Text, View } from '@react-pdf/renderer';
import { pdfStyles } from '../styles/pdf-styles';
import { PDFSectionHeader } from './PDFSectionHeader';

export interface PdfEssenceIllustrationProps {
  readonly latinName: string;
  readonly frenchName: string | null;
  readonly imageUrl: string | null;
  readonly title?: string;
}

/**
 * PDF page showing the reference illustration for an essence/species.
 */
export function PdfEssenceIllustrationPage({
  latinName,
  frenchName,
  imageUrl,
  title = 'ILLUSTRATION ESSENCE',
}: PdfEssenceIllustrationProps): React.ReactElement {
  return (
    <Page size="A4" style={pdfStyles.page}>
      <PDFSectionHeader title={title} variant="secondary" />
      <View style={{ marginTop: 12, marginBottom: 8 }}>
        <Text style={{ fontSize: 12, fontWeight: 'bold', color: '#111827' }}>{latinName}</Text>
        {frenchName ? (
          <Text style={{ fontSize: 10, color: '#4b5563', marginTop: 4 }}>{frenchName}</Text>
        ) : null}
      </View>
      {imageUrl ? (
        <View style={{ marginTop: 16, alignItems: 'center' }}>
          <Image
            src={imageUrl}
            style={{ maxWidth: 420, maxHeight: 520, objectFit: 'contain' }}
          />
        </View>
      ) : (
        <Text style={{ marginTop: 40, fontSize: 11, color: '#6b7280', textAlign: 'center' }}>
          Illustration non disponible
        </Text>
      )}
    </Page>
  );
}
